import TimeBase from "./TimeBase";

const Atletas = () => {
  return (
    <TimeBase
      pageSlug="atletas"
      timeNomeKey="TimeBase.AtletaNomeKey"
      timeDescricaoKey="TimeBase.AtletaDescricaoKey"
      tipo="ATLETA"
      excludedCountries={["PERU", "URUGUAI", "CHILE"]}
    />
  );
};

export default Atletas;
